import Vue from 'vue'
import Router from 'vue-router'
import Routes from './routes.js'

Vue.use(Router)

export default new Router(Routes)